var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 14 14",
    role: "img",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 11.050789,4.6807995 c 0.812763,0.612897 1.482232,1.405696 1.949211,2.3192 -1.114655,2.180489 -3.3830004,3.6732525 -6,3.6732525 -0.5944749,0 -1.1709588,-0.07703 -1.7200155,-0.221649 L 6.365699,9.3658875 c 0.2023064,0.0541 0.4149352,0.08295 0.634301,0.08295 1.3524539,0 2.4488345,-1.0963809 2.4488345,-2.448835 0,-0.219365 -0.028841,-0.431994 -0.082946,-0.634301 L 11.050789,4.6807995 Z M 8.7200154,3.5483969 C 8.1709586,3.4037765 7.5944748,3.3267482 7,3.3267482 c -2.6169992,0 -4.885345,1.4927633 -5.9999999,3.6732513 0.4669791,0.913505 1.1364481,1.706304 1.9492117,2.319201 l 1.6848998,-1.6849 c -0.054102,-0.202306 -0.082946,-0.414935 -0.082946,-0.634301 0,-1.352454 1.0963805,-2.448834 2.4488344,-2.448834 0.219366,0 0.4319946,0.02884 0.6343008,0.08295 L 8.7200154,3.5483969 Z M 10.896072,2.2381344 11.761866,3.1039281 3.1039283,11.761866 2.2381346,10.896072 10.896072,2.2381344 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideIcon);
export default __webpack_public_path__ + "static/media/hideIcon.d7eaa295159cb6418382f2f7b65e1074.svg";
export { ForwardRef as ReactComponent };